import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIconDragGrip = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	shapeRendering: "geometricPrecision",
	preserveAspectRatio: "xMidYMid meet",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M17.5 5C17.5 5.55228 17.0523 6 16.5 6C15.9477 6 15.5 5.55228 15.5 5C15.5 4.44772 15.9477 4 16.5 4C17.0523 4 17.5 4.44772 17.5 5Z",
			fill: "currentColor",
			stroke: "currentColor",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			vectorEffect: "non-scaling-stroke"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M8.5 12C8.5 12.5523 8.05228 13 7.5 13C6.94772 13 6.5 12.5523 6.5 12C6.5 11.4477 6.94772 11 7.5 11C8.05228 11 8.5 11.4477 8.5 12Z",
			fill: "currentColor",
			stroke: "currentColor",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			vectorEffect: "non-scaling-stroke"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M17.5 19C17.5 19.5523 17.0523 20 16.5 20C15.9477 20 15.5 19.5523 15.5 19C15.5 18.4477 15.9477 18 16.5 18C17.0523 18 17.5 18.4477 17.5 19Z",
			fill: "currentColor",
			stroke: "currentColor",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			vectorEffect: "non-scaling-stroke"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M8.5 5C8.5 5.55228 8.05229 6 7.5 6C6.94772 6 6.5 5.55228 6.5 5C6.5 4.44772 6.94772 4 7.5 4C8.05229 4 8.5 4.44772 8.5 5Z",
			fill: "currentColor",
			stroke: "currentColor",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			vectorEffect: "non-scaling-stroke"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M8.5 19C8.5 19.5523 8.05229 20 7.5 20C6.94772 20 6.5 19.5523 6.5 19C6.5 18.4477 6.94772 18 7.5 18C8.05229 18 8.5 18.4477 8.5 19Z",
			fill: "currentColor",
			stroke: "currentColor",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			vectorEffect: "non-scaling-stroke"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M17.5 12C17.5 12.5523 17.0523 13 16.5 13C15.9477 13 15.5 12.5523 15.5 12C15.5 11.4477 15.9477 11 16.5 11C17.0523 11 17.5 11.4477 17.5 12Z",
			fill: "currentColor",
			stroke: "currentColor",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			vectorEffect: "non-scaling-stroke"
		})
	]
});
export { SvgIconDragGrip as ReactComponent };
